import React from 'react';
import classNames from 'classnames';
import { Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	isHidden: boolean;
	isDisabled?: boolean;
	onlyIcon?: boolean;
}

const VisibilityBadge = (props: Props) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const { isHidden, isDisabled, onlyIcon } = props;

	return (
		<Typography
			className={classNames(classes.visibilityToggle, {
				[classes.visibilityToggleHidden]: isHidden || isDisabled,
			})}
			variant="button"
			color={isHidden ? 'textSecondary' : 'primary'}
		>
			{isHidden ? (
				<VisibilityOff fontSize="small" style={{ color: 'inherit' }} />
			) : (
				<Visibility fontSize="small" style={{ color: 'inherit' }} />
			)}
			{!onlyIcon && (
				<>
					<Box mr={0.5} />
					<span className={classes.visibilityToggleText}>
						{isHidden ? t('common:states.hidden', 'Hidden') : t('common:states.visible', 'Visible')}
					</span>
				</>
			)}
		</Typography>
	);
};

const useStyles = makeStyles((theme) => ({
	visibilityToggle: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	visibilityToggleText: {
		[theme.breakpoints.down('sm')]: {
			display: 'none',
		},
	},
	visibilityToggleHidden: {
		opacity: 0.5,
	},
}));

export default VisibilityBadge;
